import React from "react";
import PropTypes from "prop-types";
import { Link, useLocation, useRouteMatch } from "react-router-dom";
import { Row, Col, Breadcrumb as ReactstrapBreadcrumb, BreadcrumbItem } from "reactstrap";

import { APP_ROUTES, getParamsAttachedRoute } from "../../helpers/routeHelpers";
import "./Breadcrumb.scss";

const Breadcrumb = ({ title, breadcrumbItems }) => {
    const matches = useRouteMatch();
    const { pathname } = useLocation();
    const pathNameArr = pathname?.split("/");

    const routeConfigs = [
        {
            path: APP_ROUTES.PDF_LISTING,
            title: "PDF Listing",
            count: "1",
            matchUrl: "/pdf-listing",
            key: "01"
        },

        {
            path: APP_ROUTES.WEB_FORM,
            title: "Corporate Book Web Forms",
            count: "1",
            matchUrl: "/web-form",
            key: "03"
        },

        {
            path: APP_ROUTES.ACCOUNT_PROFILE,
            title: "Profile",
            count: "1",
            matchUrl: "/account/profile",
            key: "05"
        },
        {
            path: APP_ROUTES.ACCOUNT_CHANGE_PASSWORD,
            title: " Change Password",
            count: "2",
            matchUrl: "/account/change-password",
            key: "06"
        }
    ];
    const breadcrumbItemsToRender = routeConfigs.filter((el) => pathname.startsWith(el.path));

    return (
        <Row className="breadcrumbs-con">
            <Col xs="12" className="breadcrumbs-col">
                <div className="d-flex align-items-center justify-content-between">
                    <ReactstrapBreadcrumb>
                        {breadcrumbItemsToRender.map((el, idx) => {
                            const isActive =
                                pathname === el.path || pathNameArr.includes(el.matchUrl);

                            return (
                                <BreadcrumbItem
                                    key={el.key}
                                    active={isActive}
                                    className={
                                        isActive
                                            ? "breadcrumb-typo-bold breadcrumb-max-width"
                                            : "breadcrumb-max-width breadcrumb-typo-bold "
                                    }
                                >
                                    {isActive || el.count === "2" ? (
                                        <span className="breadcrumb-typo-bold">{el.title} </span>
                                    ) : (
                                        <Link
                                            to={el.path}
                                            className="breadcrumb-typo breadcrumb-max-width"
                                        >
                                            {el.title}
                                        </Link>
                                    )}
                                </BreadcrumbItem>
                            );
                        })}
                    </ReactstrapBreadcrumb>
                </div>
            </Col>
        </Row>
    );
};

Breadcrumb.propTypes = {
    breadcrumbItems: PropTypes.array,
    title: PropTypes.string
};

export default Breadcrumb;
